@if (isDataSetLoaded) {
  @if (chart) {
    <div [chart]="chart"></div>
  }
} @else {
  <div [chart]="placeholderChart" syncPulse></div>
}
